<div class="subBlockContainer" id="renewalCheckout" *ngIf="checkoutInitiated">

    <div class="blockContainer flexbox-style-one" id='levelOne'>
        <div class="combination-loader extendwidth combinedLoader">

            <div class="child-sidebar">
                <child-header title="Checkout" (closeEvent)="closeCheckoutPanel()"></child-header>
                <!-- <div class="page-title-wrapper">
                    <div class="title blade-title">
                        Checkout
                    </div>
                    <i class="material-icons closebutton-pullfloat-right" (click)="closeCheckoutPanel()">close</i>
                </div> -->

                <div class="checkoutMenu">
                    <ng-container *ngFor="let item of checkoutMenuFilter">
                        <div [id]="item.id" class="menu-wrapper cart-list-group-item"
                            [class.currentStep]="item.stepName == currentCheckoutStep"
                            [class.active]="item.stepName == currentCheckoutStep"
                             (click)="redirectTo(item.stepName);">
                            <label class="small-title">{{item.menuName}}</label>
                            <span [hidden]="item.stepName == currentCheckoutStep" class="check-wrapper">
                            </span>
                        </div>
                    </ng-container>
                </div>

            </div>

            <div class="child-loader">
                <router-outlet></router-outlet>
            </div>

        </div>
    </div>

</div>